module.exports = __webpack_public_path__ + "static/preparation-icon-bd2b6f9d1cae57edd797968ed538efc9.svg";